/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Company } from "./Company";
import {
  CompanyFromJSON,
  CompanyFromJSONTyped,
  CompanyToJSON,
  CompanyToJSONTyped,
} from "./Company";
import type { Shipment } from "./Shipment";
import {
  ShipmentFromJSON,
  ShipmentFromJSONTyped,
  ShipmentToJSON,
  ShipmentToJSONTyped,
} from "./Shipment";
import type { CarrierInvoice } from "./CarrierInvoice";
import {
  CarrierInvoiceFromJSON,
  CarrierInvoiceFromJSONTyped,
  CarrierInvoiceToJSON,
  CarrierInvoiceToJSONTyped,
} from "./CarrierInvoice";

/**
 *
 * @export
 * @interface CompanyShipmentCarrierInvoice
 */
export interface CompanyShipmentCarrierInvoice {
  /**
   *
   * @type {Company}
   * @memberof CompanyShipmentCarrierInvoice
   */
  company: Company;
  /**
   *
   * @type {Shipment}
   * @memberof CompanyShipmentCarrierInvoice
   */
  shipment: Shipment;
  /**
   *
   * @type {CarrierInvoice}
   * @memberof CompanyShipmentCarrierInvoice
   */
  carrierInvoice: CarrierInvoice;
}

/**
 * Check if a given object implements the CompanyShipmentCarrierInvoice interface.
 */
export function instanceOfCompanyShipmentCarrierInvoice(
  value: object,
): value is CompanyShipmentCarrierInvoice {
  if (!("company" in value) || value["company"] === undefined) return false;
  if (!("shipment" in value) || value["shipment"] === undefined) return false;
  if (!("carrierInvoice" in value) || value["carrierInvoice"] === undefined)
    return false;
  return true;
}

export function CompanyShipmentCarrierInvoiceFromJSON(
  json: any,
): CompanyShipmentCarrierInvoice {
  return CompanyShipmentCarrierInvoiceFromJSONTyped(json, false);
}

export function CompanyShipmentCarrierInvoiceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyShipmentCarrierInvoice {
  if (json == null) {
    return json;
  }
  return {
    company: CompanyFromJSON(json["company"]),
    shipment: ShipmentFromJSON(json["shipment"]),
    carrierInvoice: CarrierInvoiceFromJSON(json["carrierInvoice"]),
  };
}

export function CompanyShipmentCarrierInvoiceToJSON(
  json: any,
): CompanyShipmentCarrierInvoice {
  return CompanyShipmentCarrierInvoiceToJSONTyped(json, false);
}

export function CompanyShipmentCarrierInvoiceToJSONTyped(
  value?: CompanyShipmentCarrierInvoice | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    company: CompanyToJSON(value["company"]),
    shipment: ShipmentToJSON(value["shipment"]),
    carrierInvoice: CarrierInvoiceToJSON(value["carrierInvoice"]),
  };
}
